import React, {Component} from 'react';

import axios from "axios/index";
import swal from 'sweetalert2';

import urls from '../../../../utils/urls';
import {tokenHeader} from '../../../../utils/headers';
import Button from "../../../../components/Button/Button";
import arrow from '../../../../assets/download_arrow.png';
import loading from '../../../../assets/loading.gif';


export default class ExportReport extends Component {

    constructor(props){
        super(props);

        this.state = {
            ajaxInProgress: false,
            task: null,
        };
    }

    _checkTask = () => {
        let {task} = this.state;
        if(task){
            let TASK_URL = `${urls.API_ROOT}/api/v1/trip/export/${task.id}/`;
            axios.get(TASK_URL, tokenHeader())
                .then(response => {
                    let updatedTask = response.data;
                    switch(updatedTask.state){
                        case 'CREATED':
                        case 'IN_PROGRESS':
                            setTimeout(this._checkTask, 3000);
                            break;
                        case 'ERROR':
                            swal({
                                title: 'Error en el servidor',
                                html: 'No se pudo completar la descarga del reporte. Por favor refresque la página y vuelva a intentarlo.',
                                type: 'error',
                                showConfirmButton: false,
                                timer: 3000
                            });
                            this.setState({task: null, ajaxInProgress: false});
                            break;
                        case 'COMPLETE':
                            swal({
                                title: 'Reporte generado',
                                html: 'El reporte fue creado con éxito, en instántes comenzará la descarga.',
                                type: 'success',
                                showConfirmButton: false,
                                timer: 3000
                            });
                            this.setState({
                                task: null, ajaxInProgress: false
                            }, () => {
                                window.location = `${urls.API_ROOT}${updatedTask.result}`;
                            });
                            break;
                        default:
                            break;
                    }
                });
        }
    };

    _generateReport = () => {
        let filters = this.props.filters;

        this.setState({ajaxInProgress: true});

        let EXPORT_URL = `${urls.API_ROOT}/api/v1/trip/` + filters + "&type=report";
        axios.get(EXPORT_URL, tokenHeader())
            .then(response => {
                this.setState({
                    task: response.data
                }, this._checkTask);
            }).catch(e => {
            console.log(e);
            swal({
                title: 'Error en el servidor',
                html: 'No se pudo completar la descarga del reporte. Por favor refresque la página y vuelva a intentarlo.',
                type: 'error',
                showConfirmButton: false,
                timer: 3000
            });
            this.setState({task: null, ajaxInProgress: false});
        });
    };

    render() {
        if(this.props.total_trips === 0) return <div />;

        return (

            <div className={'export-button-container'}>
                <Button disabled={this.state.ajaxInProgress}
                        onClick={this._generateReport}>
                    EXPORTAR GRILLA
                    {!this.state.ajaxInProgress &&
                    <img src={arrow} alt={'Descargar'} className={'download-arrow'}/>
                    }
                    {this.state.ajaxInProgress &&
                    <img src={loading} alt={'Generando'} className={'download-arrow'}/>
                    }
                </Button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Home/Grid/ExportReport.js